



















import Vue from 'vue';
import Component from 'vue-class-component';
import UserCard from '@/components/Shared/UserCard.vue';
import {authModule, challengeModule, teamModule, teamsState} from '@/utils/store-acessor';
import {InvitationsModel, InvitationStatus, TeamModel} from '@/models/team.model';
import {ChallengeModel} from '@/models/challenge.model';

@Component({
  components: {UserCard}
})
export default class TeamMembers extends Vue {
  @teamModule.Getter('selectedTeam') team!: TeamModel;
  @teamModule.Getter('invitesByStatus') members!: (status: InvitationStatus) => InvitationsModel[];
  @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  async mounted() {
    if (this.team?.slug && this.challenge?.id && this.isAuthenticated) {
      await teamsState.fetchPendingInvites({
        slug: this.team.slug,
        challengeId: this.challenge.id
      });
    }
  }
}
